// extracted by mini-css-extract-plugin
export default {"root":"StudentPicker_root__BtjpQ"};